import { render } from "./BlogBlockForm.vue?vue&type=template&id=81a38ad8&scoped=true"
import script from "./BlogBlockForm.vue?vue&type=script&lang=js"
export * from "./BlogBlockForm.vue?vue&type=script&lang=js"

import "./BlogBlockForm.vue?vue&type=style&index=0&id=81a38ad8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81a38ad8"]])

export default __exports__